import React, { useEffect } from "react";
import { connect } from "react-redux";
import { sessionTimeout } from "../../../modules/login";

const SessionTimeoutSimulator = ({ sessionTimeout }) => {
  useEffect(() => {
    // Simulate session timeout
    sessionTimeout();
    // The sessionTimeout function already handles redirection
  }, [sessionTimeout]);

  return (
    <div>
      <h1>Simulating Session Timeout...</h1>
      <p>You will be redirected shortly.</p>
    </div>
  );
};

const mapDispatchToProps = {
  sessionTimeout,
};

export default connect(null, mapDispatchToProps)(SessionTimeoutSimulator);
